module.exports = __webpack_public_path__ + "static/flags/EC-7ced6f6a73050b56ff4278a5d75dd874.gif";